import React from "react";
import { Settings, ShieldCheck, FileText } from "lucide-react";
import { AdvancedSettingsTabProps } from "./ComponentPropsV3";

const AdvancedSettingsTabV3: React.FC<AdvancedSettingsTabProps> = ({
  feePreference,
  requireAttendeeDetails,
  setRequireAttendeeDetails,
  requirePreRegistration,
  setRequirePreRegistration,
  requireTerms,
  setRequireTerms,
  termsText,
  setTermsText,
  refundPolicy,
  setRefundPolicy,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {/* Attendee Requirements */}
      <div className="glass-panel" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div className="v3-section-head">
          <ShieldCheck size={14} color="#EE3F7C" /> Attendee Registration Controls
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 700, color: "#fff", display: "block" }}>Collect Attendee Names &amp; Details</label>
              <span style={{ fontSize: 11, color: "rgba(255,255,255,0.45)" }}>Require full name and contact information for each ticket assigned.</span>
            </div>
            <button
              type="button"
              className={`v3-toggle ${requireAttendeeDetails ? "on" : "off"}`}
              onClick={() => setRequireAttendeeDetails(!requireAttendeeDetails)}
            >
              <span className="v3-toggle-knob" />
            </button>
          </div>

          <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 12, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 700, color: "#fff", display: "block" }}>Pre-Registration Approval Required</label>
              <span style={{ fontSize: 11, color: "rgba(255,255,255,0.45)" }}>Host must manually accept attendees before tickets are issued.</span>
            </div>
            <button
              type="button"
              className={`v3-toggle ${requirePreRegistration ? "on" : "off"}`}
              onClick={() => setRequirePreRegistration(!requirePreRegistration)}
            >
              <span className="v3-toggle-knob" />
            </button>
          </div>
        </div>
      </div>

      {/* Terms & Conditions */}
      <div className="glass-panel" style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div className="v3-section-head">
          <FileText size={14} color="#EE3F7C" /> Custom Terms &amp; Policies
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 700, color: "#fff", display: "block" }}>Enforce Terms &amp; Conditions Checkbox</label>
              <span style={{ fontSize: 11, color: "rgba(255,255,255,0.45)" }}>Attendees must agree to organizer guidelines before payment.</span>
            </div>
            <button
              type="button"
              className={`v3-toggle ${requireTerms ? "on" : "off"}`}
              onClick={() => setRequireTerms(!requireTerms)}
            >
              <span className="v3-toggle-knob" />
            </button>
          </div>

          {requireTerms && (
            <div>
              <label className="v3-label">Terms Text</label>
              <textarea rows={3} className="v3-input" value={termsText} onChange={(e) => setTermsText(e.target.value)} />
            </div>
          )}

          <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 12 }}>
            <label className="v3-label">Refund Policy</label>
            <select className="v3-input" value={refundPolicy} onChange={(e) => setRefundPolicy(e.target.value)}>
              <option value="Non-refundable" style={{ background: "#0d0e15", color: "#fff" }}>Non-refundable</option>
              <option value="Up to 7 days before event" style={{ background: "#0d0e15", color: "#fff" }}>Up to 7 days before event</option>
              <option value="Up to 24 hours before event" style={{ background: "#0d0e15", color: "#fff" }}>Up to 24 hours before event</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedSettingsTabV3;
